var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.057,
    height: 13.057,
    viewBox: "0 0 13.057 13.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.528,2a6.528,6.528,0,1,0,6.528,6.528A6.528,6.528,0,0,0,8.528,2Zm.653,9.792a.653.653,0,0,1-1.306,0V7.875a.653.653,0,1,1,1.306,0ZM8.528,5.917a.979.979,0,1,1,.979-.979A.98.98,0,0,1,8.528,5.917Z",
    transform: "translate(-2 -2)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info_circle.6e01d67b8d5581af427225b2388ffb3d.svg";
export { ForwardRef as ReactComponent };